import { createContext, useContext, useState, useEffect } from "react";
import React from "react";

// Turkish → English lookup. Missing keys fall back to the passed-in text (which is Turkish).
const EN = {
  // Sidebar groups
  "Genel": "General", "CRM": "CRM", "Ürün Verisi": "Product Data", "Tedarik": "Procurement",
  "Satış": "Sales", "Üretim": "Production", "Kalite": "Quality", "Lojistik": "Logistics",
  "Finans": "Finance", "Envanter": "Inventory", "Sistem": "System",
  // Sidebar items
  "Kontrol Paneli": "Dashboard", "Ar-Ge Portalı": "R&D Portal", "Talepler / Görevler": "Requests / Tasks",
  "Müşteriler": "Customers", "Markalar": "Brands", "Ürünler": "Products", "Formüller": "Formulas",
  "Malzemeler": "Materials", "Satın Alma": "Purchasing", "Satış Siparişleri": "Sales Orders",
  "Üretim Emirleri": "Production Orders", "Kalite Kontrol": "Quality Control",
  "Bitmiş Ürünler": "Finished Products", "Sevkiyatlar": "Shipments", "İzlenebilirlik": "Traceability",
  "Finansal Analiz": "Financial Analysis", "Envanter Yönetimi": "Inventory Management",
  "Depolar": "Warehouses", "Raporlar": "Reports", "Bildirimler": "Notifications",
  "Kullanıcılar": "Users", "Sistem Ayarları": "System Settings",
  // Common buttons / actions
  "Çıkış": "Logout", "Kaydet": "Save", "Vazgeç": "Cancel", "Sil": "Delete", "Düzenle": "Edit",
  "Onayla": "Approve", "Yeni": "New", "Detay": "Details", "Kopyala": "Copy",
  "Sipariş, lot, ürün, malzeme ara...": "Search order, lot, product, material...",
  "Fason Üretim": "Contract Manufacturing",
  // Dashboard
  "Operasyonun anlık durumu": "Live operations status",
  "TRY ↔ EUR Döviz Çevirici": "TRY ↔ EUR Currency Converter",
  "Kârlılık Özeti (Tüm Zaman)": "Profitability Overview (All Time)",
  "İşçilik / Adet": "Labor / Unit", "Günlük Ort. Gider": "Daily Avg. Expense",
  "Günlük Ort. Üretim": "Daily Avg. Output", "Aktif Gün": "Active Days",
  "Kârlı Formül": "Profitable Formulas",
  "Aylık Kârlılık Trendi (Son 6 Ay)": "Monthly Profitability Trend (Last 6 Months)",
  "En Kârlı Formüller": "Most Profitable Formulas", "En Az Kârlı": "Least Profitable",
  "Gelir": "Revenue", "Direkt Maliyet": "Direct Cost", "Net Kâr": "Net Profit",
  "Açık Siparişler": "Open Orders", "Aktif Üretim": "Active Production",
  "Ham Madde QC": "Raw Material QC", "Bulk QC Bekliyor": "Bulk QC Waiting",
  "Bitmiş Ürün QC": "Finished Product QC", "Bugünün Sevkiyatları": "Today's Shipments",
  "Kritik Stok": "Critical Stock", "Yetersiz Stok": "Insufficient Stock",
  "SKT Yaklaşan": "Expiring Soon", "Geciken Siparişler": "Delayed Orders",
  "Talepler": "Requests", "Üretim Emirleri": "Production Orders",
  "Tümü": "All", "Kayıt yok": "No records",
  // Finance
  "EUR ana para birimi — Türk Lirası (TRY) ikinci gösterim": "EUR primary currency — TRY (Turkish Lira) secondary display",
  "Yeni Gider": "New Expense", "TCMB'den Güncelle": "Refresh from TCMB",
  "Analiz": "Analysis", "Kârlılık": "Profitability", "Giderler": "Expenses",
  "Kaynak": "Source", "her sabah 09:30 TR otomatik güncellenir": "auto-updated every morning at 09:30 TR",
  // Sales / Formulas
  "Yeni Formül": "New Formula", "Yeni Sipariş": "New Order",
  "Satış Fiyatı (EUR/adet)": "Sales Price (EUR/unit)", "Hedef Min. Kâr Marjı %": "Target Min. Profit Margin %",
  "Tahmini Kâr": "Estimated Profit", "Sipariş Kâr Özeti": "Order Profit Summary",
  // Finished products
  "Bitmiş ürün lotları ve stokları — Teslim butonu ile kısmi sevkiyat": "Finished lots and stock — deliver via the Deliver button",
  "Etiket Yazdır": "Print Label", "Teslim / Sevk": "Deliver / Ship",
};

const LocaleCtx = createContext({ locale: "tr", setLocale: () => {}, t: (s) => s });

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => localStorage.getItem("locale") || "tr");
  const setLocale = (l) => { localStorage.setItem("locale", l); setLocaleState(l); };
  const t = (s) => (locale === "en" && s && EN[s]) ? EN[s] : s;
  useEffect(() => { document.documentElement.lang = locale; }, [locale]);
  return <LocaleCtx.Provider value={{ locale, setLocale, t }}>{children}</LocaleCtx.Provider>;
}

export function useT() { return useContext(LocaleCtx); }
